import { http } from "services";

export const List = async ({ params }) => http.request.post('/v1/gov-service/open/pageable', {
    per_page: params.perPage,
    page: params.page,
    sort: params.sort,
    search: params.filter,
})

export const DownloadExcel = async ({ params }) => http.request.post('/v1/gov-service/open/download/excel', {
    per_page: params.perPage,
    page: params.page,
    sort: params.sort,
    search: params.filter,
    },
    {
        responseType: 'blob'
    }
)

export const Single = async ({ id }) => http.request.get(`/v1/gov-service/open/${id}`)

export const OrganizationList = ({ params }) =>
  http.request.post(
    "/v1/gov-function/open-organization/service/pageable",
    {
      per_page: params.perPage,
    },
  );